<template>
  <div class="col-md-12">
    <div class="col-12">
      <p>
        Período de pesquisa selecionado:
        <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
        <b-link
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="info"
          v-b-popover.hover.top="
            'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
          "
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
      </p>
    </div>
    <div class="col-12 no-print" v-if="showFilterReport">
      <!-- Filtros -->
      <form @submit.prevent="getAnalytics" ref="addItem">
        <div class="row">
          <form-calendar
            v-model="data_inicio"
            grid="6"
            label="Data Inicial"
            :max-date="dataNow"
          />

          <form-calendar
            v-model="data_fim"
            grid="6"
            label="Data final"
            :required="verificaDataInicial"
            :min-date="data_inicio"
            :max-date="dataNow"
          />
        </div>
        <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button class="btn btn-default" @click="$emit('hideFilter')">
              <i class="fas fa-times"></i>
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="limparFiltros()"
            >
              {{ $t("Limpar Filtros") }}
            </button>

            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="fas fa-chart-bar"></i>
              {{ $t("Gerar Relatório") }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["report", "showFilterReport", "data_inicio", "data_fim"],
  data() {
    return {};
  },
  methods: {
    limparFiltros() {
      this.$parent.filtros = {};
      this.data_inicio = "";
      this.data_fim = "";
      this.$refs.addItem.reset();
      this.$emit("limpar");
      this.$emit("loadlist");
    },
    getAnalytics() {
      this.$emit('update:data_inicio', this.data_inicio);
      this.$emit('update:data_fim', this.data_fim);
      this.$emit("loadlist");
    },
  },
};
</script>

<style>
</style>
